<template>
  <div class="add-enterprise-page">
    <van-nav-bar
      title="新增企业"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="page-content">
      <van-form @submit="onSubmit" ref="formRef" :label-width="70">
        <!-- <van-field
          name="license"
          label="营业执照"
          required
          class="custom-field"
          :rules="[{ required: true, message: '请上传营业执照' }]"
        >
          <template #input>
            <van-uploader
              v-model="formData.license"
              :after-read="afterReadLicense"
              :before-delete="beforeDeleteLicense"
              accept="image/jpeg,image/jpg,image/png"
              upload-text="jpg/png"
              :max-count="1"
            />
          </template>
        </van-field> -->

        <van-field
          v-model="formData.name"
          name="name"
          label="企业名称"
          class="custom-field"
          placeholder="请输入企业名称"
          required
          :rules="[{ required: true, message: '请输入企业名称' }]"
        />

        <!-- { pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/, message: '请输入正确的统一社会信用代码' } -->
        <van-field
          v-model="formData.socialCreditCode"
          name="socialCreditCode"
          label="统一社会信用代码"
          placeholder="请输入统一社会信用代码"
          required
          :rules="[{ required: true, message: '请输入统一社会信用代码' }]"
          class="custom-field"
        />

        <van-field
          v-model="formData.contactPhone"
          name="contactPhone"
          label="联系电话"
          class="custom-field"
          placeholder="请输入联系电话"
          type="tel"
          required
          :rules="[{ required: true, message: '请输入联系电话' }]"
        />

        <van-field
          v-model="formData.region"
          name="area"
          is-link
          readonly
          label="地域"
          placeholder="请选择地域"
          class="custom-field"
          required
          :rules="[{ required: true, message: '请选择地域' }]"
          @click="showAreaPicker = true"
        />

        <van-field
          v-model="formData.address"
          name="address"
          label="详细地址"
          placeholder="请输入详细地址"
          class="custom-field"
          required
          :rules="[{ required: true, message: '请输入详细地址' }]"
        />

        <van-field
          v-model="industryDisplayText"
          name="industry"
          is-link
          readonly
          label="行业"
          placeholder="请选择行业"
          class="custom-field"
          required
          :rules="[{ required: true, message: '请选择行业' }]"
          @click="showIndustryPicker = true"
        />

        <van-field
          v-model="formData.numberOfEmployees"
          name="numberOfEmployees"
          class="custom-field"
          label="企业人数"
          placeholder="请输入企业人数"
          type="number"
          required
          :rules="[{ required: true, message: '请输入企业人数' }]"
        />

        <van-field
          name="hazardFactor"
          label="危害因素"
          class="custom-field"
          required
          :rules="[{ required: true, message: '请选择危害因素' }]"
        >
          <template #input>
            <div class="hazard-factors">
              <van-checkbox-group
                v-model="formData.hazardFactor"
                direction="horizontal"
              >
                <van-checkbox
                  v-for="factor in hazardFactorOptions"
                  :key="factor.label"
                  :name="factor.label"
                  shape="square"
                  class="hazard-checkbox"
                >
                  {{ factor.label }}
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </template>
        </van-field>

        <van-field
          v-if="formData.hazardFactor.includes('其他因素')"
          v-model="formData.otherFactors"
          rows="3"
          autosize
          name="otherFactors"
          label="其他危害因素"
          type="textarea"
          placeholder="请输入其他危害因素"
          class="custom-field"
          required
          :rules="[{ required: true, message: '请输入其他危害因素' }]"
        />
        <van-field
          v-model="formData.numberOfContacts"
          name="numberOfContacts"
          label="接触人数"
          class="custom-field"
          placeholder="请输入接触人数"
          type="number"
          required
          :rules="[{ required: true, message: '请输入接触人数' }]"
        />

        <div class="submit-section">
          <van-button
            type="primary"
            native-type="submit"
            size="large"
            round
            block
            :loading="submitting"
            class="submit-button"
          >
            {{ submitting ? "提交中..." : "提交" }}
          </van-button>
        </div>
      </van-form>
    </div>

    <!-- 地域 -->
    <van-popup v-model:show="showAreaPicker" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onAreaConfirm"
        @cancel="showAreaPicker = false"
        title="请选择地域"
      />
    </van-popup>

    <van-popup v-model:show="showIndustryPicker" position="bottom" round>
      <van-cascader
        v-model="selectedIndustryValue"
        title="请选择行业"
        :options="industryOptions"
        @close="showIndustryPicker = false"
        @finish="onIndustryFinish"
      />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast, Dialog } from "vant";
import { postWithFile, get, post, put } from "@/request.js";
import { areaList } from "@vant/area-data";
import { getFileFullUrl } from "../../../utils";
import industryData from "@/assets/js/industry.js";

const router = useRouter();
const route = useRoute();
const id = ref(route.query.id);
const courseId = ref(route.query.courseId);
const isEdit = ref(route.query.isEdit);
const formRef = ref();
const submitting = ref(false);
const showAreaPicker = ref(false);
const showIndustryPicker = ref(false);

const formData = reactive({
  name: "",
  socialCreditCode: "",
  contactPhone: "",
  areaCode: "",
  region: "",
  address: "",
  industry: "",
  numberOfEmployees: "",
  hazardFactor: [],
  numberOfContacts: "",
  // license: [],
  // licensePath: "",
  otherFactors: "",
});

const hazardFactorOptions = [
  { label: "粉尘因素", value: "1" },
  { label: "化学因素", value: "2" },
  { label: "物理因素", value: "3" },
  { label: "放射性因素", value: "4" },
  { label: "生物因素", value: "5" },
  { label: "其他因素", value: "6" },
];

// 行业数据 - 转换为 cascader 需要的格式（label -> text）
const convertIndustryData = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data
    .map((item) => {
      if (!item || typeof item !== "object") {
        return null;
      }
      const converted = {
        text: item.label || "",
        value: item.value || "",
      };
      if (
        item.children &&
        Array.isArray(item.children) &&
        item.children.length > 0
      ) {
        converted.children = convertIndustryData(item.children).filter(
          (child) => child !== null
        );
      }
      return converted;
    })
    .filter((item) => item !== null);
};

const industryOptions = convertIndustryData(industryData);

// 调试：检查"国际组织"是否在转换后的数据中
if (process.env.NODE_ENV === "development") {
  console.log("行业数据总数:", industryOptions.length);
  const internationalOrg = industryOptions.find(
    (item) => item.text === "国际组织" || item.value === "国际组织"
  );
  console.log("国际组织数据:", internationalOrg);
}

// 选中的行业值（数组格式，用于 cascader 的 v-model）
const selectedIndustryValue = ref([]);
// 显示的行业文本
const industryDisplayText = ref("");

// 组件挂载后
onMounted(() => {
  if (id.value) {
    getCompany();
  }
});

// 方法
const onClickLeft = () => {
  router.back();
};

// 根据值查找对应的选项路径（用于回显，兼容旧数据仅存最后一级的情况）
const findIndustryPathByValue = (
  value,
  options = industryOptions,
  path = []
) => {
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    const currentPath = [...path, option.value];

    if (option.value === value) {
      return currentPath;
    }

    if (option.children && Array.isArray(option.children)) {
      const found = findIndustryPathByValue(
        value,
        option.children,
        currentPath
      );
      if (found) {
        return found;
      }
    }
  }
  return null;
};

// const afterReadLicense = (file) => {
//   uploadAvatar(file);
// };
// // 上传头像到服务器
// const uploadAvatar = async (file) => {
//   try {
//     const form = new FormData();
//     form.append("file", file.file);
//     const res = await postWithFile("/api/upload", form);
//     if (res.success && res?.data) {
//       formData.license = [{ url: res.data.url }];
//       formData.licensePath = res.data.path;
//     }

//     Toast("头像上传成功");
//   } catch (error) {
//     Toast("头像上传失败");
//   }
// };
// const beforeDeleteLicense = () => {
//   return Dialog.confirm({
//     title: "确认删除",
//     message: "确定要删除这张图片吗？",
//   })
//     .then(() => {
//       formData.license = [{ url: "" }];
//       formData.licensePath = "";
//       return true;
//     })
//     .catch(() => false);
// };

const onAreaConfirm = (values) => {
  formData.areaCode = values.map((item) => item.code).join(",");
  formData.region = values.map((item) => item.name).join("/");
  showAreaPicker.value = false;
};

// 行业选择完成事件
const onIndustryFinish = ({ selectedOptions }) => {
  if (selectedOptions && selectedOptions.length > 0) {
    // 将所有级别的 value 用 "/" 连接，完整保存行业路径
    const pathValues = selectedOptions.map((option) => option.value);
    formData.industry = pathValues.join("/");

    // 显示所有级别的文本，用 "/" 分隔
    const pathTexts = selectedOptions.map((option) => option.text);
    industryDisplayText.value = pathTexts.join("/");

    // 更新选中的值数组（用于回显）
    selectedIndustryValue.value = selectedOptions.map((option) => option.value);
  }
  showIndustryPicker.value = false;
};

const chooseEnterprise = async (companyId) => {
  const res = await put(
    `/api/my/registration/company/${courseId.value}?companyId=${companyId}`
  );
  if (res.success) {
    Toast("操作成功");
    setTimeout(() => {
      router.go(-2);
    }, 1000);
  }
};
const onSubmit = async (values) => {
  submitting.value = true;

  try {
    const params = {
      ...formData,
      license: formData.licensePath || "",
      id: id.value,
      // 直接传最后一层（第三层）的值
      industry: formData.industry,
    };
    // delete params.licensePath;
    const res = await post("/api/my/companies", params);
    if (res.success) {
      Toast("提交成功");
      if (isEdit.value == 0) {
        const companyId = res.data || "";
        chooseEnterprise(companyId);
      } else {
        localStorage.setItem(
          "fromEnterprise",
          JSON.stringify({
            courseId: courseId.value,
            refresh: true,
            companyId: res.data,
          })
        );
        router.back();
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
};
const getCompany = async () => {
  const res = await get(`/api/my/companies/${id.value}`);
  if (res.success && res?.data) {
    // 使用对象解构和扩展运算符简化赋值
    const { license, ...otherData } = res.data;

    Object.assign(formData, otherData);

    // 根据行业值查找对应的路径，用于回显
    if (otherData.industry) {
      // 兼容新旧数据：
      // - 新数据：以 "一级/二级/三级" 形式存储，直接按 "/" 拆分
      // - 旧数据：只存最后一级，需在行业树中反查路径
      let path = null;
      if (otherData.industry.includes("/")) {
        path = otherData.industry.split("/");
      } else {
        path = findIndustryPathByValue(otherData.industry);
      }
      if (path) {
        selectedIndustryValue.value = path;

        // 根据路径查找选项，显示完整路径文本
        let currentOptions = industryOptions;
        const textSegments = [];
        for (const value of path) {
          const option = currentOptions.find((opt) => opt.value === value);
          if (option) {
            textSegments.push(option.text);
            currentOptions = option.children || [];
          } else {
            break;
          }
        }
        // 显示所有级别文本，使用 "/" 分隔；找不到则回退为原始值
        industryDisplayText.value =
          textSegments.length > 0 ? textSegments.join("/") : otherData.industry;
      } else {
        // 如果找不到路径，直接显示行业值
        industryDisplayText.value = otherData.industry;
      }
    }

    // // 特殊处理需要转换的字段
    // formData.license = license ? [{ url: getFileFullUrl(license) }] : [];
    // formData.licensePath = license;
  }
};
// onMounted 已在上面定义
</script>

<style scoped lang="less">
.add-enterprise-page {
  min-height: 100vh;
}

.page-content {
  padding: 0 16px 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background: #ffffff;
  margin: 10px;
  border-radius: 12px;

  .van-form {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 16px;
    .custom-field {
      font-size: 16px;
      padding: 16px 16px;
    }
  }
}

.hazard-factors {
  width: 100%;

  .van-checkbox-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;

    .hazard-checkbox {
      .van-checkbox__label {
        font-size: 14px;
        color: #666;
      }
    }
  }
}

.submit-section {
  margin-top: 50px;

  .submit-button {
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    border: none;

    &.van-button--loading {
      background: #d1d5db;
    }
  }
}

.van-popup {
  .van-area,
  .van-cascader {
    background: white;
  }
}
</style>
